import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Carrier, ServiceListItem } from 'src/app/_models/models';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class CarriersService {

  constructor(private common: CommonService, private client: HttpClient) {

  }

  getAllProviders(): Observable<any[]> {
    //debugger;
    let url = this.common.getApiAddress();

    url = url + "/providers"

    return this.client.get<Carrier[]>(url)
      .pipe(
        map<Carrier[], Carrier[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carriers get failed", e);
        })
      );
  }
  getAll(name: string): Observable<any[]> {

    let url = this.common.getApiAddress();

    if (name == undefined || name == null) {
      url = url + "/carriers" ;
    } else {
      url = url + "/carriers?name=" + name ;
    }

    return this.client.get<Carrier[]>(url)
      .pipe(
        map<Carrier[], Carrier[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carriers get failed", e);
        })
      );
  }

  getAllCarriers(name: string,pageNumber: number, pageSize: number): Observable<any[]> {

    let url = this.common.getApiAddress();

    if (name == undefined || name == null) {
      url = url + "/carriers/getAllCarrier?pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    } else {
      url = url + "/carriers/getAllCarrier?name=" + name + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    }

    return this.client.get<Carrier[]>(url)
      .pipe(
        map<Carrier[], Carrier[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carriers get failed", e);
        })
      );
  }
  getAllServices(): Observable<any[]> {

    let url = this.common.getApiAddress();
    url = url + "/carriers/getAllServices";

    return this.client.get<ServiceListItem[]>(url)
      .pipe(
        map<ServiceListItem[], ServiceListItem[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Get service list failed", e);
        })
      );
  }

  get(id: number, action: string): Observable<any> {

    return this.client.get<Carrier[]>(this.common.getApiAddress() + "/carriers/" + id.toString() + "?action=" + action + "&name=''")
      .pipe(
        map<any, any>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carriers get failed", e);
        })
      );
  }

  create(data: Carrier): Observable<Carrier> {
    return this.client.post<Carrier>(this.common.getApiAddress() + "/carriers", data)
      .pipe(
        map<Carrier, Carrier>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Create carrier failed", e);
        })
      );
  }

  update(data: Carrier): Observable<Carrier> {
    return this.client.put<Carrier>(this.common.getApiAddress() + "/carriers/" + data.id, data)
      .pipe(
        map<Carrier, Carrier>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Edit carrier failed", e);
        })
      );
  }

  delete(id: number): Observable<Carrier> {
    return this.client.delete<Carrier>(this.common.getApiAddress() + "/carriers/" + id.toString())
      .pipe(
        map<Carrier, Carrier>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Carrier delete failed", e);
        })
      );
  }



  mapCarrier(object: any): Observable<any> {
    var url = this.common.getApiAddress() + "/clients/MapCarriersForClient";
    if (object.Id > 0)
      url = this.common.getApiAddress() + "/clients/UpdateMapCarriersForClient";
    return this.client.post<any>(url, object)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Map carrier failed", e);
        })
      );
  }

  deleteMappedCarrier(clientId?: number, carrierId?: number, childCarrier?: string): Observable<any[]> {

    let url = this.common.getApiAddress();


    url = url + "/clients/DeleteMapCarriersForClient?clientId=" + clientId + "&carrierId=" + carrierId;
    if (childCarrier != null && childCarrier.length > 0)
      url += + "&childCarrier=" + childCarrier;


    return this.client.delete<any[]>(url)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Remove carrier failed", e);
        })
      );
  }



  saveChildAccount(object: any): Observable<any> {
    return this.client.post<any>(this.common.getApiAddress() + "/carriers/SaveChildAccount", object)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Save child account failed", e);
        })
      );
  }

  deleteChildAccount(childAccountId?: number): Observable<any[]> {

    let url = this.common.getApiAddress();


    url = url + "/carriers/DeleteChildAccount?childAccountId=" + childAccountId;

    return this.client.delete<any[]>(url)
      .pipe(
        map<any[], any[]>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Remove carrier failed", e);
        })
      );
  }

}
